import {
    type interfaces,
    ContainerModule,
} from '@patsnap/tahiti-core/shared/inversify';

// Apis
import { DocumentParseApiImpl } from './apis/impls/document-parse-api';
import { DocumentParseApi } from './apis/document-parse-api';

export const documentParseModule = new ContainerModule((bind: interfaces.Bind) => {
    // Bind Apis
    bind(DocumentParseApi).to(DocumentParseApiImpl);
});

// Re-export types and constants
export * from './types';
export * from './constants';
export * from './apis/document-parse-api';
